import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiLayout } from 'react-icons/fi';

const Screenshots = () => {
  return (
    <section className="py-20 px-4 bg-bgDark/50">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          <div className="order-2 lg:order-1 flex justify-center">
            <div className="relative max-w-[320px] w-full">
              <div className="absolute -inset-4 bg-primary/20 rounded-full blur-3xl"></div>
              <div className="relative bg-bgDark border border-borderDark rounded-[2.5rem] p-3 shadow-2xl overflow-hidden">
                <div className="bg-cardBg rounded-[1.8rem] overflow-hidden border border-borderDark min-h-[400px] flex items-center justify-center">
                  <img 
                    src="/popup-preview.png" 
                    alt="Interface" 
                    className="w-full h-auto"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentNode.innerHTML += '<div class="p-10 text-center text-textMuted text-sm">Interface-Bild (/public/popup-preview.png)</div>';
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-medium mb-6">
              <SafeIcon icon={FiLayout} />
              <span>Modernes Interface</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight">
              Intuitive Bedienung, <br />
              <span className="text-primary">volle Kontrolle.</span>
            </h2>
            <p className="text-lg text-textMuted mb-8 leading-relaxed">
              Über das übersichtliche Popup-Menü haben Sie schnellen Zugriff auf alle wichtigen Funktionen. 
              Aktivieren Sie die Sperre mit einem Klick oder passen Sie Ihre Sicherheitseinstellungen 
              in Sekunden an.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Screenshots;